import React from 'react';
import ConfirmDialog from '../ui/ConfirmDialog';

interface ConfirmPackDialogProps {
  open: boolean;
  /** How many assignments are being marked packed. */
  assignments: number;
  /** How many checklist lines that will pack (lines already packed are left alone). */
  lines: number;
  loading: boolean;
  error: string | null;
  onClose: () => void;
  onConfirm: () => void;
}

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

/** The confirmation before "Mark packed": packing moves stock, so it says how much will be packed. */
const ConfirmPackDialog: React.FC<ConfirmPackDialogProps> = ({ open, assignments, lines, loading, error, onClose, onConfirm }) => (
  <ConfirmDialog
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    variant="primary"
    title={assignments === 1 ? 'Mark this assignment packed?' : `Mark ${assignments} assignments packed?`}
    subject={plural(assignments, 'assignment', 'assignments')}
    description={
      lines > 0
        ? `${plural(lines, 'unpacked line', 'unpacked lines')} will be packed and taken out of stock. Lines that are already packed are left alone. An assignment with no checklist is marked complete.`
        : 'Nothing is left to pack on a checklist. Assignments with no checklist are marked complete.'
    }
    confirmLabel="Mark packed"
    loading={loading}
    error={error}
  />
);

export default ConfirmPackDialog;
